import React, { useContext, useEffect } from "react";
import {
  isoLanguagesMobileNames,
  nativeLanguageNames,
  languageCodes,
  translatedVariants,
} from "@/src/Utils/translationObject";
import { Language } from "@mui/icons-material";
import { Box, FormControl, MenuItem, Select, SvgIcon } from "@mui/material";
import { usePathname, useRouter } from "next/navigation";
import { UserContext } from "@/src/Contexts/UserContext";

function LanguageSelection(props: { sx?: React.CSSProperties; id: string }) {
  const { setfetching, setLangSwitch } = useContext(UserContext);
  const router = useRouter();

  const activeLanguage =
    typeof window !== "undefined"
      ? localStorage.getItem("TUTORCERT_LANGUAGE")
      : "";
  const pathname = usePathname();

  useEffect(() => {
    if (activeLanguage === "") {
      localStorage.setItem(`TUTORCERT_LANGUAGE`, "");
    } else if (activeLanguage === "es") {
      // router.push("/es");
    }
  }, []);

  const handleChangeEnglish = () => {
    localStorage.setItem(`TUTORCERT_LANGUAGE`, "");
    if (pathname === "/user/my-account") {
      router.refresh();
    } else {
      setLangSwitch(true);
      router.push("/");
    }
  };

  const handleChangeLanguage = (code: string) => {
    localStorage.setItem(`TUTORCERT_LANGUAGE`, code);
    if (pathname === "/user/my-account") {
      router.refresh();
    } else {
      setLangSwitch(true);
      setfetching(true);
      router.push(`/${code}`);
    }
  };

  return (
    <>
      <FormControl sx={props.sx} id="language-select-desktop">
        <Select
          id="language-select"
          size="small"
          value={
            props.id === "" || !props.id
              ? "English"
              : nativeLanguageNames[
                  props.id as keyof typeof nativeLanguageNames
                ]
          }
          sx={{ borderRadius: "8px" }}
          renderValue={(value: string) => {
            return (
              <Box sx={{ display: "flex", gap: 1 }}>
                <SvgIcon color="action">
                  <Language />
                </SvgIcon>
                {props.id === "" || !props.id
                  ? "English"
                  : nativeLanguageNames[
                      props.id as keyof typeof translatedVariants
                    ]}
              </Box>
            );
          }}
        >
          {languageCodes
            ? languageCodes.map((lang) => {
                let langName = lang.name;
                if (lang.name === "English") {
                  langName =
                    props.id === "" || !props.id
                      ? "English"
                      : translatedVariants[
                            props.id as keyof typeof translatedVariants
                          ]
                        ? translatedVariants[
                            props.id as keyof typeof translatedVariants
                          ].english
                        : translatedVariants.en.english;
                }
                return (
                  <MenuItem
                    key={lang.name}
                    value={lang.name}
                    onClick={() =>
                      lang.name === "English"
                        ? handleChangeEnglish()
                        : handleChangeLanguage(lang.code)
                    }
                  >
                    {langName}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>

      <FormControl sx={props.sx} id="language-select-mobile">
        <Select
          id="language-select"
          sx={{ borderRadius: "8px" }}
          value={
            props.id === "" || !props.id
              ? "EN"
              : isoLanguagesMobileNames[
                  props.id as keyof typeof nativeLanguageNames
                ]
          }
          renderValue={(value: string) => {
            return (
              <Box sx={{ display: "flex", gap: 1 }}>
                <SvgIcon color="action">
                  <Language />
                </SvgIcon>
                {value}
              </Box>
            );
          }}
        >
          {languageCodes
            ? languageCodes.map((lang) => {
                let langName = lang.name;
                if (lang.name === "English") {
                  langName =
                    props.id === "" || !props.id
                      ? "English"
                      : translatedVariants[
                          props.id as keyof typeof translatedVariants
                        ].english;
                }
                return (
                  <MenuItem
                    key={lang.name}
                    value={lang.name}
                    onClick={() =>
                      lang.name === "English"
                        ? handleChangeEnglish()
                        : handleChangeLanguage(lang.code)
                    }
                  >
                    {langName}
                  </MenuItem>
                );
              })
            : null}
        </Select>
      </FormControl>
    </>
  );
}

export default LanguageSelection;
